export default {"src":"/_next/static/media/TSN.49d4fcb6.svg","height":18,"width":18};